import React, { useState, useEffect } from 'react';
import Highcharts from 'highcharts'
import HighchartsReact from 'highcharts-react-official';
import { getNewChartData } from '../../../api';

const IMG_URL = process.env.IMG_FULL_URL;

const xAxisColor = "#808080";

const WorkAccidentsSectorChart = (props) =>
{

    const [isLoading, setIsLoading] = useState(true);
    const [chartConfig, setChartConfig] = useState({
        title: {
            text: '<h2 class="title--card">' + props.title + '</h2>',
            align: 'left',
            widthAdjust: -50,
            style: {
                zIndex: 1,
                lineHeight:36
            }
        },
        credits: {
            enabled: true,
            text: "",
            href: '',
            style: {
                cursor: 'arrow'
            },
            position: {
                x: -130
            }
        },
        colors: props.colors,
        chart: {
            type: 'column',
            backgroundColor: '#F0F0F0',
            events: {
                render: function() {
                    let chart = this;
                    if (!chart.customImage)
                    {
                        chart.customImage = chart.renderer.image(
                            `${IMG_URL}osh-barometer/img/EU-OSHA-en.png`,
                            chart.chartWidth - 130,
                            chart.chartHeight - 37,
                            130,
                            37
                        ).add();
                        chart.customImage.attr({
                            class:'osha-logo'
                        });
                    }
                    else
                    {
                        chart.customImage.attr({
                            x: chart.chartWidth - 130,
                            y: chart.chartHeight - 37
                        });
                    }
            
                    if (chart.fullscreen.isOpen) {
                        chart.customImage.css({
                            display: 'block'
                        });
                        chart.container.className = 'highcharts-container full-screen';
                    }
                    else
                    {
                        chart.customImage.css({
                            display: ''
                        });	
                        chart.container.className = 'highcharts-container';
                    }
                }					
            }
        },
        exporting: {
            enabled: props.fullCountryReport == true ? false : true,
            sourceWidht: 1200,
            sourceHeight: 600,
            buttons: {
                contextButton: {
                    menuItems: ["viewFullscreen", "printChart", "separator", "downloadPNG", "downloadJPEG", "downloadPDF", "downloadSVG", "separator", "downloadCSV", "downloadXLS"]							
                }
            },
            filename: props.title.replace(/ /g, '_'),
            tableCaption: props.title
        },
        responsive: {
            rules: [{
                condition: {
                    maxWidth: 767
                },
                chartOptions: {
                    chart: {
                        type: 'bar'
                    }
                }
            }]
        },
        navigation: {
            buttonOptions: {
                theme: {
                    fill: 'transparent',
                    states: {
                        hover: {
                            fill: '#CCC'
                        },
                        select: {
                            fill: 'transparent'
                        }
                    }
                }
            }
        },
        yAxis: {
            gridLineColor: '#FFF',
            gridLineWidth: 2,
            startOnTick: true,
            endOnTick: true,
            tickInterval: props.step ? props.step : null,
            max: props.yAxisMax ? props.yAxisMax : null,
            title: {
                text: ''
            },
            labels: {
                format: props.percentage === true ? '{value}%' : `{value}`,
                style: {
                    fontFamily: 'OpenSans-bold',
                    fontWeight: 'normal',
                    fontSize:  props.fullCountryReport ? '10px' : '12px',
                    textOverflow: 'none'
                }
            }
        },
        xAxis: {
            lineWidth: 0,
            labels: {	
                style: {
                    fontFamily: 'OpenSans-bold',
                    fontWeight: 'normal',
                    fontSize: props.fullCountryReport ? '10px' : '12px' ,
                    textOverflow: 'ellipsis'
                }
            }
        },
        tooltip: {},
        plotOptions: {},
        series: []
    })

    useEffect(() => {
        setIsLoading(true);

        // Remove the series so the colours are correctly applied when setting the new configuration
        setChartConfig({
            ...chartConfig,
            series: []
        })

        if (props.showDataFor == 'country')
        {
            let filter = {
                chart: props.chart.id,
                indicator: props.chart.indicator,
                country1: props.selectedCountry1,
                country2: props.selectedCountry2,
                country3: props.selectedCountry3
            }
            getNewChartData(filter)
            .then((res) => {
                setChartConfig({
                    ...chartConfig,
                    colors: props.colors,
                    xAxis: {
                        ...chartConfig.xAxis,
                        plotLines: [],
                        categories: res.resultset.xAxisCategories
                    },
                    series: res.resultset.data
                })
                setIsLoading(false);
            })
        }
        else if (props.showDataFor == 'sector' && (props.sector1 != null || props.sector2 != null || props.sector3 != null))
        {
            let filter = {
                chart: props.chart.id,
                indicator: props.chart.indicator,
                sector1: props.sector1,
                sector2: props.sector2,
                sector3: props.sector3
            }
            getNewChartData(filter)
            .then((res) => {
                setChartConfig({
                    ...chartConfig,
                    colors: props.colors,
                    xAxis: {
                        ...chartConfig.xAxis,
                        categories: res.resultset.xAxisCategories,
                        plotLines: [
                            {
                                color: 'black',
                                width: 2,
                                value: 0.5,
                                id: 'break-eu',
                                zIndex:1
                            },
                            {
                                color: 'black',
                                width: 2,
                                value: 27.5,
                                id: 'break-country',
                                zIndex:1
                            }
                        ],
                    },
                    series: res.resultset.data
                })
                setIsLoading(false);
            })
        }
    }, [props.chart, props.sector1, props.sector2, props.sector3, props.selectedCountry1, props.selectedCountry2, props.selectedCountry3])

    return (
        <div className='chart-container'>
            <HighchartsReact
                highcharts={Highcharts}
                options={chartConfig}
                containerProps={{ className: 'chartContainer' }}
            />
        </div>
    )
}

export default WorkAccidentsSectorChart;